import {
  ConsentDialog as C15TConsentDialog,
  ConsentWidget,
  useTranslations,
} from 'c15t/react';
import { PATHS } from '@belong/common';
import { Button, Text } from '@belong/ui';
import { STRINGS } from '../../strings';
import { ConsentCategoriesList } from '../consent-categories-list/consent-categories-list';

const DIALOG_LINK_CLASSNAME =
  'font-semibold uppercase transition-colors duration-[100ms] hover:text-dark-navy';

export function ConsentDialog() {
  const translations = useTranslations();

  return (
    <C15TConsentDialog.Root className="font-sans">
      <C15TConsentDialog.Card className="overflow-auto md:w-default-modal">
        <C15TConsentDialog.Header className="p-sm">
          <C15TConsentDialog.HeaderTitle className="mx-auto text-navy">
            <div className="contents md:hidden">
              <Text fontWeight="semibold">
                {translations.consentManagerDialog.title}
              </Text>
            </div>
            <div className="hidden md:contents">
              <Text variant="h3" fontWeight="semibold">
                {translations.consentManagerDialog.title}
              </Text>
            </div>
          </C15TConsentDialog.HeaderTitle>
          <C15TConsentDialog.HeaderDescription className="text-navy">
            <Text as="span" variant="p1">
              {translations.consentManagerDialog.description}{' '}
              <a
                href={PATHS.PRIVACY_POLICY}
                className={DIALOG_LINK_CLASSNAME}
                target="_blank"
                rel="noopener noreferrer"
              >
                {STRINGS.privacyPolicyLink}
              </a>
              ,{' '}
              <a
                href={PATHS.TERMS}
                className={DIALOG_LINK_CLASSNAME}
                target="_blank"
                rel="noopener noreferrer"
              >
                {STRINGS.termsOfServiceLink}
              </a>
            </Text>
          </C15TConsentDialog.HeaderDescription>
        </C15TConsentDialog.Header>
        <C15TConsentDialog.Content className="px-sm pb-sm">
          <ConsentWidget.Root>
            <ConsentCategoriesList />
            {/* Symmetric for the same CPPA reason as the banner. */}
            <ConsentWidget.Footer className="font-sans flex flex-wrap items-center justify-between gap-xs pt-xs md:pt-sm">
              <ConsentWidget.SaveButton asChild noStyle>
                <Button variant="text" className="whitespace-nowrap">
                  {translations.common.save}
                </Button>
              </ConsentWidget.SaveButton>
              <div className="flex items-center gap-sm md:gap-lg">
                <ConsentWidget.RejectButton asChild noStyle>
                  <Button variant="text" className="whitespace-nowrap">
                    {translations.common.rejectAll}
                  </Button>
                </ConsentWidget.RejectButton>
                <ConsentWidget.AcceptAllButton asChild noStyle>
                  <Button
                    variant="text"
                    buttonType="secondary"
                    className="whitespace-nowrap"
                  >
                    {translations.common.acceptAll}
                  </Button>
                </ConsentWidget.AcceptAllButton>
              </div>
            </ConsentWidget.Footer>
          </ConsentWidget.Root>
        </C15TConsentDialog.Content>
        <C15TConsentDialog.Footer hideBranding />
      </C15TConsentDialog.Card>
    </C15TConsentDialog.Root>
  );
}
